<template>
  <div id="record">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl()">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        详情
        <!-- <img src="@/assets/logo.png" width="21" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>-->
      </div>
      <!-- <div class="right" @click="toHome()">
        <van-icon name="wap-home" size="21" />
      </div> -->
    </div>
    <div class="padding content" v-if="type==1">
     <van-loading v-show="showL" type="spinner" style="text-align:center" />
      <div class="info-tit">{{info.title}}</div>
      <div class="info-time"><span>{{info.author==''?'青山湖智慧残联':info.author}}</span>{{info.create_time}}</div>
      <div class="eye-div" style="color:#C8C8C8;display:flex">
              <van-icon name="eye-o" size="16" color="#C8C8C8" />
              <span style="font-size:0.6rem">{{info.view}}</span>
      </div>
      <div class="infos" v-html="info.content"></div>
    </div>
     <div class="padding content" v-if="type==2">
      <van-loading v-show="showL" size="16" style="text-align:center">加载中..</van-loading>
      <div class="info-tit">{{info.name}}</div>
      <div class="info-time" v-show="!showL">{{info.create_time | formatDate}}</div>
      <div class="info-img">
        <img :src="info.picture" />
      </div>
      <div class="infos">{{info.description}}</div>

    </div>
  </div>
</template>
<script>
import { Icon, Field, Loading } from "vant";
import { articleInfo ,venueInfo,view} from "@/api/apiData";
import { formatDate } from "@/public/getFormatDate.js";
export default {
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Loading.name]: Loading,
  },
  data() {
    return {
      info: [],
      type:'',
      showL:true
    };
  },
   filters: {
    //方法一: yyyy-MM-dd hh:mm
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      console.log(date)
      return formatDate(date, "yyyy-MM-dd hh:mm");
    }
  },
  mounted() {
    let id = this.$route.query.id;
    let type = this.$route.query.type;
    this.type = type
    if(type==1){
    this.getIntro(id);
    }else{
    this.getVenue(id);
    }
  },
  methods: {
    toUrl() {
      this.$router.go(-1);
    },
    toHome(){
      window.location.href="http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403"
      // this.$router.push('/index');
    },
    getIntro(id) {
      articleInfo({ id: id }).then((res) => {
        this.info = res.data;
        this.showL = false
      });
    },
    getVenue(id) {
      venueInfo({ id: id }).then((res) => {
        this.info = res.data;
        this.showL = false
      });
    },
  },
};
</script>
<style scoped>
.info-tit{
    font-weight: bold;
}
.content{
        width: 90%;
    margin: 0 auto;
    /* padding-top: 1rem; */
    /* margin-top: 10%; */
    text-align: left;
}
.info-tit{
        font-weight: bold;
    font-size: 1.2rem;
    margin: 1rem 0;
}
.info-time{
        font-size: 0.9rem;
    color: gray;
}
.info-time span{
    color: #72b550;
    margin-right: 1rem;
}
.infos{
    font-size: 1rem;
    /* text-indent: 2rem; */
}

.info-img{
  text-align: center;
  margin: 1rem 0;
}
.info-img img{
  width: 80%;
  margin: 0 auto;
}
.eye-div{
  margin-top: 0.5rem;
}
.eye-div span{
  line-height: 1.2rem;
    margin-left: 0.2rem;
    font-size: 0.6rem;
}
</style>


// WEBPACK FOOTER //
// src/page/noticeInfo.vue